module.exports = __webpack_public_path__ + "01f43047/img/chevron-down-icon.5542f65c.svg";